import script from "./DeviceObdSection.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceObdSection.vue?vue&type=script&setup=true&lang=js"

import "./DeviceObdSection.vue?vue&type=style&index=0&id=0cd3bd46&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cd3bd46"]])

export default __exports__